"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callLoadTranslations = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
function callLoadTranslations(translationsUrl, lang) {
    return abortable_fetch_1.abortableFetch(`${translationsUrl}/load/${lang}`, {
        method: 'GET',
    });
}
exports.callLoadTranslations = callLoadTranslations;
//# sourceMappingURL=locale-api.js.map